import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InfoStoreModule } from '@wonder-core-ng/info-store/info-store.module';
import { ConditionApiService } from './condition.api.service';
import { ConditionEffects } from './condition.effects';
import * as fromCondition from './condition.reducer';
import { ConditionService } from './condition.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromCondition.conditionFeatureKey, fromCondition.reducer),
    EffectsModule.forFeature([ConditionEffects]),
    InfoStoreModule,
  ],
  providers: [ConditionApiService, ConditionService],
})
export class ConditionStoreModule {}
